"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivaCard = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var ActivaCard = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ActivaCard, _super);
    function ActivaCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '激活会员卡';
        _this.code = '300404';
        _this.desc = '激活会员卡';
        _this.requestParams = new guMember_1.ActiveCardRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ActivaCard;
}(service_1.BaseService));
exports.ActivaCard = ActivaCard;
//# sourceMappingURL=activaCard.js.map